import { Context } from "../context.js";
import log, { LoggingLevel } from "../log.js";
import Policy from "./policy.js";
import { UploadResult } from "./uploader.js";
import { GLEAN_VERSION } from "../constants.js";
import { PingBodyOverflowError } from "./ping_body_overflow_error.js";
import PingRequest from "./ping_request.js";
const PING_UPLOAD_WORKER_LOG_TAG = "core.Upload.PingUploadWorker";
class PingUploadWorker {
    constructor(uploader, serverEndpoint, policy = new Policy()) {
        this.uploader = uploader;
        this.serverEndpoint = serverEndpoint;
        this.policy = policy;
        this.isBlocking = false;
    }
    buildPingRequest(ping) {
        let headers = ping.headers || {};
        headers = {
            ...ping.headers,
            "Content-Type": "application/json; charset=utf-8",
            Date: new Date().toISOString(),
            "X-Telemetry-Agent": `Glean/${GLEAN_VERSION} (JS on ${(Context.platform).info.os()})`
        };
        const stringifiedBody = JSON.stringify(ping.payload);
        if (stringifiedBody.length > this.policy.maxPingBodySize) {
            throw new PingBodyOverflowError(`Body for ping ${ping.identifier} exceeds ${this.policy.maxPingBodySize}bytes. Discarding.`);
        }
        headers["Content-Length"] = stringifiedBody.length.toString();
        return new PingRequest(ping.identifier, headers, stringifiedBody, this.policy.maxPingBodySize);
    }
    async attemptPingUpload(ping) {
        try {
            const finalPing = this.buildPingRequest(ping);
            return this.uploader.post(`${this.serverEndpoint}${ping.path}`, finalPing);
        }
        catch (e) {
            log(PING_UPLOAD_WORKER_LOG_TAG, ["Error trying to build or post ping request:", e], LoggingLevel.Warn);
            return new UploadResult(1);
        }
    }
    work(getUploadTask, processUploadResponse) {
        while (true) {
            try {
                const task = getUploadTask();
                switch (task.type) {
                    case "upload": {
                        if (this.isBlocking) {
                            return;
                        }
                        this.attemptPingUpload(task.ping)
                            .then((result) => {
                            processUploadResponse(task.ping, result);
                        })
                            .catch((error) => {
                            console.log(error);
                        });
                        continue;
                    }
                    case "done":
                        return;
                }
            }
            catch (error) {
                log(PING_UPLOAD_WORKER_LOG_TAG, ["IMPOSSIBLE: Something went wrong while processing ping upload tasks.", error], LoggingLevel.Error);
            }
        }
    }
    blockUploading() {
        this.isBlocking = true;
    }
    resumeUploading() {
        this.isBlocking = false;
    }
}
export default PingUploadWorker;
